import { Export } from 'src/components/export';

export default Export;
